import { RegisterAttribute } from './RegisterAttribute'

export default RegisterAttribute
